import React from "react";
import {Route} from "react-router-dom";
import EditBilateralContract from "../../pages/bilateral/contract/edit";
import BilateralBidAdmin from "../../pages/bilateral/bid/BilateralBidAdminContainer";
import AddBilateralOrderAdmin from "../../pages/bilateral/bid/add/AddBilateralBidAdminContainer";
import BilateralControlPanel from "../../pages/bilateral/controlPanel/BilateralControlPanelContainer"
import BilateralControlPanelDetail from "../../pages/bilateral/controlPanel/detailLoan/BilateralDetailLoanContainer";
import BilateralAgreement from "../../pages/bilateral/controlPanel/captureGuarantee/BilateralCaptureGuaranteeContainer";
import BilateralMoveTitleCollateral from "../../pages/bilateral/controlPanel/moveTitleCollateral/BilateralMoveTitleCollateralContainer";
import BilateralMaturity from "../../pages/bilateral/controlPanel/maturity/BilateralMaturityContainer";
import BilateralMarginCall from "../../pages/bilateral/controlPanel/marginCall/BilateralMarginCallContainer";
import BilateralExcess from "../../pages/bilateral/controlPanel/excess/BilateralExcessContainer";
import BilateralHistory from "../../pages/bilateral/controlPanel/history/BilateralLoanLogHistoryContainer";

import {
    EDIT_BILATERAL_CONTRACT_ROUTE,
    BILATERAL_BID_ADMIN_ROUTE,
    ADD_BILATERAL_BID_ADMIN_ROUTE,
    BILATERAL_CONTROL_PANEL_ROUTE,
    BILATERAL_CONTROL_PANEL_DETAIL_LOAN_ROUTE,
    BILATERAL_CONTROL_PANEL_CAPTURE_GUARANTEE,
    BILATERAL_CONTROL_PANEL_MOVE_TITLE_GUARANTEE,
    BILATERAL_CONTROL_PANEL_MATURITY,
    BILATERAL_CONTROL_PANEL_MARGIN_CALL,
    BILATERAL_CONTROL_PANEL_EXCESS_LOAN,
    BILATERAL_CONTROL_PANEL_HISTORY
} from "../../utils/constants/RoutesConstants";

const BilateralRoutes = () => {
    return (
        <React.Fragment>
            <Route path={EDIT_BILATERAL_CONTRACT_ROUTE} component={EditBilateralContract}/>
            <Route path={BILATERAL_BID_ADMIN_ROUTE} component={BilateralBidAdmin}/>
            <Route path={ADD_BILATERAL_BID_ADMIN_ROUTE} component={AddBilateralOrderAdmin}/>

            <Route path={BILATERAL_CONTROL_PANEL_ROUTE} component={BilateralControlPanel}/>
            <Route path={BILATERAL_CONTROL_PANEL_DETAIL_LOAN_ROUTE} component={BilateralControlPanelDetail}/>
            <Route path={BILATERAL_CONTROL_PANEL_CAPTURE_GUARANTEE} component={BilateralAgreement}/>
            <Route path={BILATERAL_CONTROL_PANEL_MOVE_TITLE_GUARANTEE} component={BilateralMoveTitleCollateral}/>
            <Route path={BILATERAL_CONTROL_PANEL_MATURITY} component={BilateralMaturity}/>
            <Route path={BILATERAL_CONTROL_PANEL_MARGIN_CALL} component={BilateralMarginCall}/>
            <Route path={BILATERAL_CONTROL_PANEL_EXCESS_LOAN} component={BilateralExcess}/>
            <Route path={BILATERAL_CONTROL_PANEL_HISTORY} component={BilateralHistory}/>

        </React.Fragment>
    );
};

export default BilateralRoutes;